import { useQuery } from 'react-query'

import { getAgencies } from '@/api/agency/get-agencies'

export const useGetAgencies = () => {
  return useQuery({
    queryKey: ['agencies'],
    queryFn: getAgencies,
  })
}
